module.exports = __webpack_public_path__ + "assets/img/title-recom-config-87f30144.png";